import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import AppInput from "../../components/forms/AppInput";
import ChangeLangButton from "../../components/language/ChangeLangButton";
import { forgotPassword } from "../../api/endpoints/auth";
import { useContext, useState } from "react";
import imgPlaceholder from "../../assets/img/session-placeholeder.png";
import PlaceHolder from "../../components/placeHolder.tsx/PlaceHolder";
import { ApiResponse } from "../../api/apiResponse";
import { ToastContext } from "../../App";
import AppLogo from "../../components/AppLogo";

function ForgotPasswordPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isForgetSent, setIsForgetSent] = useState(false);
  const toast = useContext(ToastContext);
  const LocalBasePath = "page.forgotPassword";
  //   TO USE FOR TRANSLATION:  {t(`${LocalBasePath}.`)} replace your key after dot
  const onSendEmaile = async (data: { email: string }) => {
    try {
      const response: ApiResponse = await forgotPassword(data.email);
      if (response.isSuccess) {
        setIsForgetSent(true);
      } else if (response.statusCode === 404) {
        toast?.error(t(`${LocalBasePath}.emailDoesNotExists`));
      } else {
        toast?.error("unableToSubmitYourAudioFile");
      }
    } catch (error) {
      toast?.error("unableToSubmitYourAudioFile");
      setIsForgetSent(false);
    }
    //   TODO:  Restore Password API call gose here
    // navigate("/restore-password");
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = (data: any) => {
    onSendEmaile(data);
  };

  return (
    <div className="flex flex-col justify-between min-h-screen px-4 py-12 sm:px-6 lg:px-8">
      <div>
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <AppLogo />
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            {t(`${LocalBasePath}.restorePassword`)}
          </h2>
        </div>
        {isForgetSent ? (
          <div className="text-center" data-cy="success-message">
            <PlaceHolder img={imgPlaceholder} title="recoveryForgetPassword" />
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
              <button
                onClick={() => navigate("/login")}
                className="w-full px-4 py-2 mt-4 text-sm font-medium text-white rounded-md shadow-sm bg-brandblue-600 hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500"
              >
                {t(`page.login.signIn`)}
              </button>
            </div>
          </div>
        ) : (
          <div className=" sm:mx-auto sm:w-full sm:max-w-md">
            <p className="mt-2 text-sm text-gray-600">
              {t(`${LocalBasePath}.restorePasswordSubtitle`)}
            </p>
            <div className="">
              <div className="mt-8 ">
                <div className="mt-6">
                  <form
                    onSubmit={handleSubmit(onSubmit)}
                    data-cy="restore-password-form"
                  >
                    <div className="space-y-6">
                      <div>
                        <AppInput
                          label={t(`${LocalBasePath}.email`)}
                          id="email"
                          type="email"
                          autoComplete="email"
                          placeholder="example@gmail.com"
                          error={errors.email}
                          name="email"
                          register={register}
                          scehema={{
                            required: true,
                            pattern: /^\S+@\S+$/i,
                          }}
                        />
                      </div>
                    </div>

                    <div className="mt-12">
                      <button
                        type="submit"
                        className="flex justify-center w-full px-4 py-2 text-sm font-medium text-white border border-transparent rounded-md shadow-sm bg-brandblue-600 hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500"
                      >
                        {t(`${LocalBasePath}.send`)}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <ChangeLangButton />
    </div>
  );
}
export default ForgotPasswordPage;
